// src/components/modal.js — modal reutilizável simples (overlay + card).
// API:
//   import { openModal, closeModal } from '@/components/modal.js';
//   openModal({ title, bodyHTML, buttons: [{label, action: 'cancel'|'submit'|fn, kind?}] });

import './modal.css';
import { trapFocus } from '../lib/dom.js';

let _state = null;

// Tokens shadcn vivem em .sc-scope — como o modal é portal no <body>, a raiz
// carrega o escopo, senão var(--primary)/--background não resolvem (viram preto).
const _scopeClass = () => 'sc-scope' + (document.documentElement.classList.contains('light') ? '' : ' dark');

export function openModal(config) {
  if (_state) closeModal();

  const wrap = document.createElement('div');
  wrap.id = 'modal-wrap';
  wrap.className = _scopeClass();
  wrap.innerHTML = `
    <div class="mod-overlay" data-action="cancel"></div>
    <div class="mod-card ${config.size || ''}" role="dialog" aria-modal="true"${config.title ? ` aria-label="${_esc(config.title)}"` : ''}>
      <header class="mod-head">
        <div class="mod-tt">
          <h3>${_esc(config.title || '')}</h3>
          ${config.codigo ? `<div class="mod-meta"><span class="mod-chip">${_esc(config.codigo)}</span>${config.sub ? `<span class="mod-sub">${_esc(config.sub)}</span>` : ''}</div>` : ''}
        </div>
        <div class="mod-head-act">
          <button class="mod-help" data-action="help" title="Reportar problema (captura de tela)" aria-label="Abrir chamado"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><path d="M12 8v4M12 16h.01"/></svg></button>
          <button class="mod-close" data-action="cancel" aria-label="Fechar">×</button>
        </div>
      </header>
      <div class="mod-body">${config.bodyHTML || ''}</div>
      <footer class="mod-foot">
        ${(config.buttons || []).map((b, i) => `
          <button class="mod-btn ${b.kind || 'secondary'}" data-btn="${i}">${_esc(b.label)}</button>
        `).join('')}
      </footer>
    </div>
  `;
  document.body.appendChild(wrap);
  _state = { config };

  requestAnimationFrame(() => {
    wrap.querySelector('.mod-overlay').classList.add('is-open');
    wrap.querySelector('.mod-card').classList.add('is-open');
  });

  _state.soltarFoco = trapFocus(wrap.querySelector('.mod-card'));

  wrap.addEventListener('click', async (e) => {
    if (e.target.closest('[data-action="help"]')) { (async () => { const shot = window._capturarTelaSuporte ? await window._capturarTelaSuporte() : null; window.abrirModalChamado?.(shot); })(); return; }
    if (e.target.closest('[data-action="cancel"]')) return closeModal();
    const btnIdx = e.target.dataset.btn;
    if (btnIdx != null) {
      const btn = config.buttons[Number(btnIdx)];
      if (!btn) return;
      const btnEl = e.target;
      const originalText = btnEl.textContent;
      btnEl.disabled = true;
      btnEl.textContent = 'Processando…';
      try {
        if (btn.action === 'cancel') closeModal();
        else if (typeof btn.action === 'function') {
          const r = await btn.action();
          if (r !== false) closeModal();
        }
      } finally {
        btnEl.disabled = false;
        btnEl.textContent = originalText;
      }
    }
  });

  // ESC fecha
  const esc = (e) => { if (e.key === 'Escape') closeModal(); };
  document.addEventListener('keydown', esc);
  _state.escHandler = esc;

  // Navegacao fecha: sem isto, o #modal-wrap fica preso no DOM ao trocar de rota
  // (o router so faz teardown de drawers) e o overlay reaparece sobre outras telas.
  const onHash = () => closeModal();
  window.addEventListener('hashchange', onHash);
  _state.hashHandler = onHash;
}

export function closeModal() {
  const wrap = document.getElementById('modal-wrap');
  // Cleanup dos listeners globais sempre — mesmo se o wrap ja tiver sido removido.
  if (_state?.escHandler) document.removeEventListener('keydown', _state.escHandler);
  if (_state?.hashHandler) window.removeEventListener('hashchange', _state.hashHandler);
  if (_state?.soltarFoco) _state.soltarFoco();   // devolve o foco a quem abriu
  if (!wrap) { _state = null; return; }
  wrap.querySelector('.mod-overlay')?.classList.remove('is-open');
  wrap.querySelector('.mod-card')?.classList.remove('is-open');
  setTimeout(() => {
    wrap.remove();
    _state = null;
  }, 220);
}

function _esc(s) {
  if (s == null) return '';
  return String(s).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c]));
}
